import { Form } from 'antd';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import { getProductsEffect } from '../../../../redux/shipment/ShipmentEffects';
import FormAutoComplete from '../../Inputs/FormAutoComplete';
import HiddenFormInput from '../../Inputs/HiddenFormInput';

const ProductSelector = ({
  placeholder = i18n.t('translation:default.fields.product.placeholder'),
  label = i18n.t('translation:default.fields.product.label'),
  rules = [],
  name,
  editMode,
  margin,
  singleLineMode,
  inverMode,
  onChange = () => {},
  colon,
  form = {},
  tabIndex,
  disableValidation = false,
}) => {
  const { selectedCompany } = useSelector((state) => state.auth);
  const value = Form.useWatch(name, form); // To re-render the component once the value is updated

  const handleChange = (val) => {
    const codeValue = val['1'] ? val['1'] : val?.productCode;
    form.setFieldsValue({ [name]: codeValue });
    onChange(val);
  };

  return (
    <div className="async-select-box">
      <FormAutoComplete
        id={`${name}-origin`}
        placeholder={placeholder}
        label={label}
        rules={rules}
        editMode={editMode}
        margin={margin}
        singleLineMode={singleLineMode}
        inverMode={inverMode}
        colon={colon}
        asyncFetchMode
        asyncFunction={getProductsEffect}
        defaultParams={{
          CustomerKey: selectedCompany?.companyId,
          PageSize: 10,
          PageNumber: 1,
        }}
        onChange={handleChange}
        value={value}
        accessors={{ label: 'productCode', value: 'productCode' }}
        onClear={() => form.setFieldsValue({ [name]: undefined })}
        tabIndex={tabIndex}
        disableValidation={disableValidation}
      />
      <HiddenFormInput name={name} rules={rules} disableValidation={disableValidation} />
    </div>
  );
};

export default ProductSelector;
